export enum ExportDocumentEnum {
  PDF = 1,
  EXCEL = 2,
  TXT = 3,
}

export enum PrintShipmenttEnum {
  DocumentoBolsillo = 1,
  EtiquetaBomPequenna = 2,
  EtiquetaBomGrande = 3,
  EtiquetaBomAmbas = 4,
  EtiquetaZebra = 5,
  EtiquetaZebra10x10 = 6,
}
